module.exports = __webpack_public_path__ + "assets/img/favicon/android-icon-192x192.eac2b947dab892cb9e06f6f6fa8d1f4d.png";